import * as UI from "../../../../modules/ui-kit";

export default function SpecificationConfiguration(props) {
    const { onChange, value } = props;

    if (!value) {
        return (
            <UI.Field>
                <UI.Button
                    onClick={ () => onChange({}) }
                >
                    Configure
                </UI.Button>
            </UI.Field>
        );
    }

    const writer = {
        bimClassIDs: (bimClassIDs: string[]) => onChange({ ...(value ?? {}), bimClassIDs }),
        rootCategoryID: (rootCategoryID: string) => onChange({ ...(value ?? {}), rootCategoryID }),
        customSpecification: (customSpecification: boolean) => onChange({ ...(value ?? {}), customSpecification }),
        realSpecification: (realSpecification: boolean) => onChange({ ...(value ?? {}), realSpecification }),
    };

    return (
        <UI.Field>
            <UI.Field>
                <UI.FieldLabel>BIM Classes</UI.FieldLabel>
                <UI.ListInput
                    onChange={ writer.bimClassIDs }
                    value={ value?.bimClassIDs ?? [] }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Root category</UI.FieldLabel>
                <UI.TextInput
                    onChange={ writer.rootCategoryID }
                    value={ value?.rootCategoryID ?? undefined }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Custom specification</UI.FieldLabel>
                <UI.SegmentedControl
                    onChange={ writer.customSpecification }
                    options={
                        [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    }
                    value={ value?.customSpecification }
                />
            </UI.Field>
            <UI.Field>
                <UI.FieldLabel>Real specification</UI.FieldLabel>
                <UI.SegmentedControl
                    onChange={ writer.realSpecification }
                    options={
                        [
                            { label: "Yes", value: true },
                            { label: "No", value: false },
                        ]
                    }
                    value={ value?.realSpecification }
                />
            </UI.Field>
            <UI.Button
                onClick={ () => onChange(undefined) }
            >
                Remove specification configuration
            </UI.Button>
        </UI.Field>
    );
}
